import { v4 as uuidv4 } from "uuid";

export const propertyTypes = [
  {
    value: "Single Family",
  },
  {
    value: "Mulit Family",
  },
  {
    value: "Student-Housing",
  },
  {
    value: "Manufactured-Housing",
  },
  {
    value: "Self Storage",
  },
  {
    value: "Commercial",
  },
  {
    value: "Mixed Use",
  },
  {
    value: "HOA",
  },
  {
    value: "Vacation",
  },
];

export const portfolio = [{ value: "SayEagle" }, { value: "another" }];

export const eligibleCharge = [
  { value: "Delinquency" },
  { value: "Gross Potential Rent" },
  { value: "Insurance Services" },

  { value: "Integrity Lease Break Fee" },

  { value: "Landlord Liability Insurance - Admin Fee" },

  { value: "Lease Break Fee" },

  { value: " Lease prep fee" },

  { value: "Loss/Gain to Market" },

  { value: "Month-to-Month Fee" },

  { value: "rent concession account" },

  { value: "Section 8 Rent" },

  { value: "Security Deposit Waiver Admin Fee" },

  { value: "Security Deposit Waiver Program" },

  { value: "Tax Passthru" },

  { value: "Vacancy" },

  { value: "103: Rent Income" },

  { value: " 104: Association Fee Income" },

  { value: "108: Late Fee Income" },

  { value: "112: Application Fee Income" },

  { value: "113: NSF Fee Income" },

  { value: "115: Convenience Fee" },

  { value: "116: Tenant Benefit Package - New" },

  { value: "117: Owner Contribution Convenience Fee" },

  { value: "200: SN Insurance" },

  { value: "23265: Interest Income" },

  { value: "23266: Laundry Income" },

  { value: "23267: Cleaning and Maint Income" },

  { value: "23268: Other Income" },

  { value: " 23269: Parking Income" },

  { value: "23270: Repairs Income" },

  { value: "23271: Pet Rent Income" },

  { value: "23271-1: Utility Income" },

  { value: "403873: app fee" },

  { value: " 412874: Mailing Fee" },

  { value: "9000: Sd transfer end of mgmt" },

  { value: " 997: Eviction Notice Fee" },

  { value: " 998: tbp" },

  { value: " 999: closing out property" },
];

export const bankAccounts = [
  { value: "Rent Income Account (Bank Name)" },
  { value: "Security Deposit Account (Bank Name)" },
];

export const numberOfDaysInMonth = [...new Array(31)].map((each, index) => ({
  value: index + 1,
}));

export const propertyGroup = [
  { value: "SayEagle Property Group" },
  { value: "other Property Group" },
];

export const basis = [{ value: "Cash" }, { value: "Accrual" }];

export const initialList = [
  {
    id: uuidv4(),
  },
];

export const leaseSettingList = [
  {
    title: "Default New Lease Templates",
    li: initialList,
  },
  {
    title: "Default Renewal Templates",
    li: initialList,
  },
  {
    title: "Default Renewal Month to Month Templates",
    li: initialList,
  },
];

export const renewalOptionsTerms = [
  { value: "Month to Month" },
  { value: "3 Months" },
  { value: "6 Months" },
  { value: "9 Months" },
  { value: "12 Months" },
  { value: "15 Months" },
  { value: "18 Months" },
  { value: "21 Months" },
  { value: "24 Months" },
];
